import { render, staticRenderFns } from "./mobile-carousel.vue?vue&type=template&id=4246a046&scoped=true"
import script from "./mobile-carousel.vue?vue&type=script&lang=js"
export * from "./mobile-carousel.vue?vue&type=script&lang=js"
import style0 from "./mobile-carousel.vue?vue&type=style&index=0&id=4246a046&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4246a046",
  null
  
)

export default component.exports